import { z } from 'zod/v4'

export const passwordFieldSchema = z.string().min(1, 'Password is required')
